import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {useUser} from "../hooks/useUser.ts";

export const EditFormDrawer = (props: DrawerProps) => {
    const {id: userId} = useParams();

    if (typeof userId === 'undefined') {
        throw new Error('userId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = useUser(userId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
